import './style.css'
import * as THREE from 'three'

// /**
//  * Base
//  */
// // Canvas
// const canvas = document.querySelector('canvas.webgl')

// // Sizes
// const sizes = {
//     width: 800,
//     height: 600
// }

// // Scene
// const scene = new THREE.Scene()

// // Object
// const mesh = new THREE.Mesh(
//     new THREE.BoxGeometry(1, 1, 1, 5, 5, 5),
//     new THREE.MeshBasicMaterial({ color: 0xff0000 })
// )
// scene.add(mesh)

// // Camera
// const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
// camera.position.x = 2
// camera.position.y = 2
// camera.position.z = 2
// camera.lookAt(mesh.position)
// scene.add(camera)

// // Renderer
// const renderer = new THREE.WebGLRenderer({
//     canvas: canvas
// })
// renderer.setSize(sizes.width, sizes.height)

// // Animate
// const clock = new THREE.Clock()

// const tick = () =>
// {
//     const elapsedTime = clock.getElapsedTime()

//     // Update objects
//     mesh.rotation.y = elapsedTime;

//     // Render
//     renderer.render(scene, camera)

//     // Call tick again on the next frame
//     window.requestAnimationFrame(tick)
// }

// tick()

const canvasText = document.getElementById('ourMission2');
const ctx = canvasText.getContext("2d");
canvasText.height = window.innerHeight;
canvasText.width = window.innerWidth;
ctx.fillStyle = "black"

let _particleArray = [];

const mouse = {
    x: null,
    y: null,
    radius: null,
}

canvasText.addEventListener('mousemove', function(event) {
    mouse.x = event.clientX;
    mouse.y = event.clientY;
    mouse.radius = 200;
    // console.log(mouse.x, mouse.y)
})

ctx.font = `6em aloneInSpace`;
ctx.fillText("I'm" + " " + "Alain", canvasText.width / 200, 90);
const textCoordinates = ctx.getImageData(0, 0, 6700, 100);

class Particle {
    constructor(x, y) {
        this.x = x;
        this.y = y - 120;
        this.size = 1;
        this.baseX = this.x + 400;
        this.baseY = this.y + 500;
        this.density = (Math.random() * 40) + 1;
    }
    draw() {
        ctx.fillStyle = 'black';
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.closePath();
        ctx.fill();
    }
    update() {
        let dx = mouse.x - this.x
        let dy = mouse.y - this.y
        let distance = Math.sqrt(dx * dx + dy * dy);
        let forceDirectionX = dx / distance;
        let forceDirectionY = dy / distance;
        let maxDistance = mouse.radius;
        let force = (maxDistance - distance) / maxDistance;
        let directionX = forceDirectionX * force * this.density;
        let directionY = forceDirectionY * force * this.density;

        if (distance < mouse.radius) {
            //this.size = 15;
            this.x -= directionX;
            this.y -= directionY;
        } else {
            if (this.x !== this.baseX) {
                let dx = this.x - this.baseX;
                this.x -= dx / 10;
            }
            if (this.y !== this.baseY) {
                let dy = this.y - this.baseY;
                this.y -= dy / 10;
            }
        }
        //console.log(dx)
    }
}


const init = () => {
    _particleArray = []
    for (let y = 0, y2 = textCoordinates.height; y < y2; y++) {
        for (let x = 0, x2 = textCoordinates.width; x < x2; x++) {
            if (textCoordinates.data[(y * 4 * textCoordinates.width) + (x * 4) + 3] > 128) {
                let positionX = x;
                let positionY = y;
                _particleArray.push(new Particle(positionX * 3, positionY * 3))
            }
        }
    }
}
init()

window.addEventListener('resize', () => {
        canvasText.width = window.innerWidth
        canvasText.height = window.innerHeight
    })
    //console.log(_particleArray)


const animate = () => {
    ctx.clearRect(0, 0, canvasText.width, canvasText.height);
    for (let i = 0; i < _particleArray.length; i++) {
        _particleArray[i].draw();
        _particleArray[i].update();
    }
    requestAnimationFrame(animate)
}

animate(); 